<template>
  <article
    class="clients"
    id="clients">
    <p class="clients__title">Nuestros clientes</p>
    <section class="clients__images">
      <img :src="image.img" alt="" v-for="(image, index) in images">
    </section>
  </article>
</template>

<script>
export default {
  data(){
    return{
      images: [
        {img:'https://ippassets.s3.us-east-2.amazonaws.com/canacol.jpg'},
        {img:'https://ippassets.s3.us-east-2.amazonaws.com/geoproduction.png'},
        {img:'https://ippassets.s3.us-east-2.amazonaws.com/sls+energy.png'},
        {img:'https://ippassets.s3-us-west-2.amazonaws.com/sls.png'},
        {img:'https://ippassets.s3.us-east-2.amazonaws.com/carrao+energy.jpg'},
        {img:'https://ippassets.s3.us-east-2.amazonaws.com/interoil.png'},
        {img:'https://ippassets.s3.us-east-2.amazonaws.com/qaqc.png'},
        // {img:'https://ippassets.s3-us-west-2.amazonaws.com/petroworks-compressor.png'},
        {img:'https://ippassets.s3.us-east-2.amazonaws.com/independence.png'},
        // {img:'https://ippassets.s3-us-west-2.amazonaws.com/petroleos_sudamericanos.jpeg'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Clients.vue